import * as Yup from "yup";

export const SuppliersFormSchema = Yup.object().shape({
  code: Yup.string()
    .trim()
    .required("Please enter code")
    .matches(/\S+/, "Code cannot contain only whitespace"),
  country: Yup.string()
    .trim()
    .required("Please enter country")
    .matches(/\S+/, "Country cannot contain only whitespace"),
  state: Yup.string()
    .trim()
    .required("Please enter state")
    .matches(/\S+/, "State cannot contain only whitespace"),
  city: Yup.string()
    .trim()
    .required("Please enter city")
    .matches(/\S+/, "City cannot contain only whitespace"),
  address: Yup.string()
    .trim()
    .required("Please enter address")
    .matches(/\S+/, "Address cannot contain only whitespace"),
  longitude: Yup.string()
    .trim()
    .required("Please enter longitude")
    // .matches(/\S+/, "Longitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid longitude"),
  latitude: Yup.string()
    .trim()
    .required("Please enter latitude")
    // .matches(/\S+/, "Latitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid latitude"),
});

export const PlantFormSchema = Yup.object().shape({
  code: Yup.string()
    .trim()
    .required("Please enter code")
    .matches(/\S+/, "Code cannot contain only whitespace"),
  state: Yup.string()
    .trim()
    .required("Please enter state")
    .matches(/\S+/, "State cannot contain only whitespace"),
  city: Yup.string()
    .trim()
    .required("Please enter city")
    .matches(/\S+/, "City cannot contain only whitespace"),
  longitude: Yup.string()
    .trim()
    .required("Please enter longitude")
    // .matches(/\S+/, "Longitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid longitude"),
  latitude: Yup.string()
    .trim()
    .required("Please enter latitude")
    // .matches(/\S+/, "Latitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid latitude"),
  plantName: Yup.string()
    .trim()
    .required("Please enter plant name")
    .matches(/\S+/, "plant name cannot contain only whitespace"),
});

export const TerminalFormSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("Please enter name")
    .matches(/\S+/, "Name cannot contain only whitespace"),
  longitude: Yup.string()
    .trim()
    .required("Please enter longitude")
    // .matches(/\S+/, "Longitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid longitude"),
  latitude: Yup.string()
    .trim()
    .required("Please enter latitude")
    // .matches(/\S+/, "Latitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid latitude"),
});

export const MeetingPointFormSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("Please enter name")
    .matches(/\S+/, "Name cannot contain only whitespace"),
  longitude: Yup.string()
    .trim()
    .required("Please enter longitude")
    // .matches(/\S+/, "Longitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid longitude"),
  latitude: Yup.string()
    .trim()
    .required("Please enter latitude")
    // .matches(/\S+/, "Latitude cannot contain only whitespace"),
    .matches(/^-?\d*\.?\d*$/, "Please enter valid latitude"),
});

export const RouteFromSchema = Yup.object().shape({
  customer: Yup.string()
    .trim()
    .required("Please enter customer")
    .matches(/\S+/, "customer cannot contain only whitespace"),
  puroute: Yup.string()
    .trim()
    .required("Please enter puroute")
    .matches(/\S+/, "Puroute cannot contain only whitespace"),
  routeDate: Yup.string()
    .trim()
    .required("Please select route date")
    .matches(/\S+/, "route date cannot contain only whitespace"),
  specMiles: Yup.string()
    .trim()
    .required("Please enter spec miles")
    // .matches(/\S+/, "spec miles cannot contain only whitespace"),
    .matches(/^\d*\.?\d*$/, "Spec miles must contain only numbers"),
  rteType: Yup.string()
    .required("Please enter RTE type")
    .matches(/\S+/, "RTE type cannot contain only whitespace"),
  relay: Yup.string()
    .required("Please enter relay")
    .matches(/\S+/, "relay cannot contain only whitespace"),
  frequency: Yup.string()
    .required("Please enter frequency")
    // .matches(/\S+/, "frequency cannot contain only whitespace"),
    .matches(/^[0-9]+$/, "Frequency must contain only numbers"),
  period: Yup.string()
    .required("Please enter period")
    .matches(/\S+/, "period cannot contain only whitespace"),
  periodYear: Yup.string()
    .required("Please select period year")
    .matches(/\S+/, "Puroute cannot contain only whitespace"),
  pudTime: Yup.string()
    .required("Please select pud time")
    .matches(/\S+/, "pud time cannot contain only whitespace"),
  suppliersIds: Yup.array().of(
    Yup.object().shape({
      id: Yup.string()
        .trim()
        .required("Please select supplier")
        .matches(/\S+/, "Supplier ID cannot contain only whitespace"),
      arriveTime: Yup.string()
        .trim()
        .required("Please select time")
        .matches(/\S+/, "Arrive time cannot contain only whitespace"),
      departTime: Yup.string()
        .trim()
        .required("Please select time")
        .matches(/\S+/, "Depart time cannot contain only whitespace"),
      arriveDate: Yup.string()
        .trim()
        .required("Please select date")
        .matches(/\S+/, "Arrive date cannot contain only whitespace"),
      departDate: Yup.string()
        .trim()
        .required("Please select date")
        .matches(/\S+/, "Depart date cannot contain only whitespace"),
    })
  ),
  plant_id: Yup.string()
    .trim()
    .required("Please select plant")
    .matches(/\S+/, "Plant ID cannot contain only whitespace"),
  plantArrivalTime: Yup.string()
    .trim()
    .required("Please select time")
    .matches(/\S+/, "Arrive time at plant cannot contain only whitespace"),
  plantArrivalDate: Yup.string()
    .trim()
    .required("Please select date")
    .matches(/\S+/, "Arrive date at plant cannot contain only whitespace"),
  plantDepartTime: Yup.string()
    .trim()
    .required("Please select time")
    .matches(/\S+/, "Depart time at plant cannot contain only whitespace"),
  plantDepartDate: Yup.string()
    .trim()
    .required("Please select date")
    .matches(/\S+/, "Depart date at plant cannot contain only whitespace"),
});

export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required("Please enter user name")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter valid user name"),
  password: Yup.string().required("Please enter password."),
});
